import { ChangeEvent, useState, useEffect } from 'react';
import Checkbox from '../../../juristec-ui/core/Checkbox';
import InputNumberLine from '../../../juristec-ui/core/InputNumberLine';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import Button from '../../../juristec-ui/core/Button';
import {
  MainContainer, InputContainer, InputRow, InputColumn,
} from './styled';

interface SessionManagerProps {
  sessionTimeout?: number;
  close: () => void;
  submit: (time: number) => void;
}

const DEFAULT_TIMEOUT = 60 * 60 * 1000;

const SessionManager = ({
  sessionTimeout,
  close,
  submit,
}: SessionManagerProps) => {
  const [timeoutTime, setTimeoutTime] = useState<string|number>(1);
  const [noTimeout, setNoTimeout] = useState<boolean>(false);

  useEffect(() => {
    const tOut = sessionTimeout ?? DEFAULT_TIMEOUT;
    setNoTimeout(tOut === 0);
    setTimeoutTime(Math.floor(tOut ? (tOut / DEFAULT_TIMEOUT) : tOut).toString());
  }, [sessionTimeout]);

  const handleEventTimeoutTime = (e: ChangeEvent<HTMLInputElement>) => {
    setTimeoutTime(e.target.value);
  };

  const handleSetTimeoutTime = (value: string|number) => {
    setTimeoutTime(value);
  };

  const toggleNoTimeout = () => {
    setTimeoutTime(noTimeout ? '1' : '0');
    setNoTimeout(!noTimeout);
  };

  const handleSubmit = () => {
    submit(Number(timeoutTime) * DEFAULT_TIMEOUT);
  };

  return (
    <MainContainer>
      <InputContainer as={InputColumn} style={{ marginTop: '5px' }}>
        <InputRow>
          <span>Expirar sessão em (horas)</span>
          <InputNumberLine
            // @ts-expect-error not typed yet
            value={timeoutTime}
            onChange={handleEventTimeoutTime}
            setValue={handleSetTimeoutTime}
            min={0}
            step={1}
            numContainerStyle={{
              flex: '1',
              maxWidth: '150px',
              ...(noTimeout ? { opacity: '0.3', pointerEvents: 'none', cursor: 'not-allowed' } : {}),
            }}
            style={{ textAlign: 'center' }}
            disabled={noTimeout}
          />
        </InputRow>
        <Checkbox
          text="Sem tempo de expiração"
          color="primary"
          variant="outlined"
          className="no-timeout-checkbox"
          checked={noTimeout}
          handleCheckboxChange={toggleNoTimeout}
          style={{ margin: '10px 0 0 auto' }}
        />
      </InputContainer>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          disabled={Number(timeoutTime) === 0 && !noTimeout}
        >
          Alterar
        </Button>
      </ActionsGroup>
    </MainContainer>
  );
};

export default SessionManager;
